import { forwardRef, useId, type ReactNode } from "react";

import { ErrorHint } from "../ErrorHint";
import { Input, InputWrapper, type InputProps } from "../Input";
import { Label } from "../Label";

export type InputFieldProps = InputProps & {
  label?: ReactNode;
  error?: string;
  wrapperClassName?: string;
  labelClassName?: string;
};

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(
  (
    {
      label,
      error,
      wrapperClassName,
      labelClassName,
      variant,
      id,
      ...inputProps
    },
    ref,
  ) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;

    return (
      <InputWrapper className={wrapperClassName}>
        {label ? (
          <Label htmlFor={inputId} className={labelClassName}>
            {label}
          </Label>
        ) : null}
        <Input
          ref={ref}
          id={inputId}
          variant={error ? "error" : (variant ?? "default")}
          {...inputProps}
        />
        {error ? <ErrorHint>{error}</ErrorHint> : null}
      </InputWrapper>
    );
  },
);
InputField.displayName = "InputField";
